(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-tennis/assets/javascripts/league.js') >= 0) return;  svs.modules.push('/components/themes/sport-tennis/assets/javascripts/league.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_tennis = svs.themes.sport_tennis || {};
})(svs);

 })(window);